"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ErrorPageLink = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _UEPB = require("../elements/UEPB");

var _UEPB2 = _interopRequireDefault(_UEPB);

var _ButtonFields = require("../form/ButtonFields");

var _ButtonFields2 = _interopRequireDefault(_ButtonFields);

var _reactRouter = require("react-router");

require("../../assets/css/components/error/ErrorsPages.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ErrorsPages = function (_React$Component) {
    _inherits(ErrorsPages, _React$Component);

    function ErrorsPages(props) {
        _classCallCheck(this, ErrorsPages);

        var _this = _possibleConstructorReturn(this, (ErrorsPages.__proto__ || Object.getPrototypeOf(ErrorsPages)).call(this, props));

        _this.state = {
            code: "",
            desc: "",
            mensg: ""
        };
        return _this;
    }

    _createClass(ErrorsPages, [{
        key: "componentWillMount",
        value: function componentWillMount() {
            this.getErrorCode();
        }
    }, {
        key: "getLogo",
        value: function getLogo() {
            return _react2.default.createElement(
                "div",
                { className: "logo-error" },
                this.props.logo ? this.props.logo : _react2.default.createElement(_UEPB2.default, null)
            );
        }
    }, {
        key: "getLinks",
        value: function getLinks() {
            if (this.props.links) {
                return this.props.links;
            }

            return _react2.default.createElement(
                "ul",
                null,
                _react2.default.createElement(ErrorPageLink, { url: "http://www.uepb.edu.br", descricao: "Site da UEPB" })
            );
        }
    }, {
        key: "getErrorCode",
        value: function getErrorCode() {
            var code = this.props.codigo || 404;
            var desc = "";
            var mensg = "";

            switch (code) {
                case 401:
                    desc = "Permissão negada";
                    mensg = "Autorização não permitida para visualização do recurso solicitado.";
                    break;
                case 404:
                    desc = "Recurso não encontrado";
                    mensg = "Não encontramos o recurso solicitado, tente novamente ou entre em contato com suporte.";
                    break;
                default:
                    desc = this.props.descricao || "Recurso não encontrado";
                    mensg = this.props.mensagem || "Não encontramos o recurso solicitado, tente novamente ou entre em contato com suporte.";
                    break;
            }

            this.setState({ code: code, desc: desc, mensg: mensg });
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                "div",
                null,
                this.getLogo(),
                _react2.default.createElement(
                    "div",
                    { className: "content" },
                    _react2.default.createElement(
                        "div",
                        { className: "erro-code" },
                        _react2.default.createElement(
                            "div",
                            null,
                            this.state.code
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "error-subtitle" },
                            this.state.desc
                        )
                    ),
                    _react2.default.createElement(
                        "div",
                        null,
                        _react2.default.createElement(
                            "div",
                            { className: "mensagem" },
                            this.state.mensg
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "links" },
                            _react2.default.createElement(
                                "span",
                                { className: "error-subtitle" },
                                "Links que talvez lhe interesse"
                            ),
                            this.getLinks()
                        )
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "btn-voltar" },
                    _react2.default.createElement(_ButtonFields2.default, { button: "colored", color: "blue", content: "Voltar Para a P\xE1gina Anterior", onClick: function onClick() {
                            return _this2.props.router.goBack();
                        } })
                )
            );
        }
    }]);

    return ErrorsPages;
}(_react2.default.Component);

exports.default = (0, _reactRouter.withRouter)(ErrorsPages);

var ErrorPageLink = exports.ErrorPageLink = function (_React$Component2) {
    _inherits(ErrorPageLink, _React$Component2);

    function ErrorPageLink() {
        _classCallCheck(this, ErrorPageLink);

        return _possibleConstructorReturn(this, (ErrorPageLink.__proto__ || Object.getPrototypeOf(ErrorPageLink)).apply(this, arguments));
    }

    _createClass(ErrorPageLink, [{
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                "li",
                null,
                _react2.default.createElement(
                    "a",
                    { href: this.props.url || "#" },
                    this.props.descricao || ""
                )
            );
        }
    }]);

    return ErrorPageLink;
}(_react2.default.Component);


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/error/ErrorsPages.js
// module id = 1116
// module chunks = 0